import execute_on from "../../../../libs/execute-on";
import {attachDataTablesLive} from "../../../../plugins/datatables/live";
import {attachDataTablesReady} from "../../../../plugins/datatables/ready";
import {attachDataTablesCompleted} from "../../../../plugins/datatables/completed";
import {attachDataTablesDraft} from "../../../../plugins/datatables/draft";
import {getCsrfToken} from "../../../../plugins/get-csrf-token";
import {swalErrorFire, swalFire} from "../../../../plugins/sweet-alert/sweet-alert-default";
import {removeMarkedRows, showAnkieterData} from "../../report/manage-data";
import {attachNumber} from "../../../../components/form/number";
import {handleSweetAlertModal} from "../../../../plugins/datatables/shared";

execute_on('survey.company.list', function ($page) {
    const status = getStatusFromURL() || 'live';
    run('/panel/survey/list/partials/' + status);
    $page
        .on('click', '#manage-data', showAnkieterData)
        .on('click', '#manage-data-delete', removeMarkedRows)
        .on('click', '.showCopySurveyPopup', showCopySurveyPopup)
        .on('submit', '.submitCopySurveyPopup', submitCopySurveyPopup)
        .on('click', '.restoreSurveyButton', showRestoreSurveyPopup);
});

/*
    Funkcja wybiera jaki typ tabeli podpiąć w widoku na podstawie url.
 */
function run(url) {
    window.handleSweetAlertModal = handleSweetAlertModal;
    $("#survey-table-placeholder").html("<p>loading...</p>");
    $.get(url,null,function(result) {
        $("#survey-table-placeholder").html(result);
        $('.nav-link').removeClass('active');
        switch (url.split("/").pop()) {
            case 'live':
                $('li.nav-link:nth-child(1) > a:nth-child(1)').addClass('active');
                attachDataTablesLive($('body'), url, 10);
                break;
            case 'ready-to-go':
                $('li.nav-link:nth-child(2) > a:nth-child(1)').addClass('active');
                attachDataTablesReady($('body'), url, 10);
                break;
            case 'draft':
                $('li.nav-link:nth-child(3) > a:nth-child(1)').addClass('active');
                attachDataTablesDraft($('body'), url, 10);
                break;
            case 'completed':
                $('li.nav-link:nth-child(4) > a:nth-child(1)').addClass('active');
                attachDataTablesCompleted($('body'), url, 10);
                break;
        }
        $(".company-list-navbar").click(function (ev) {
            run(ev.currentTarget.attributes["data-url"].value);
        });

    },'html');
}

function getStatusFromURL() {
    const queryString = window.location.search;
    const urlParams   = new URLSearchParams(queryString);

    return urlParams.get('status');
}

/*
   Poniżej są modale i popupy uruchamiane w tabelach Datatables.
 */

function showCopySurveyPopup(event) {
    event.preventDefault();

    const url = $(event.currentTarget).prop('href');
    const $surveyCopyModal = $('#surveyCopyModal');

    $surveyCopyModal
        .modal('show')
        .find('.modal-content')
        .html('<div class="m-5 text-center">' +
            '<div class="spinner-border mb-3" role="status"></div>' +
            '<strong class="d-block">Loading data, please wait...</strong>' +
            '</div>')
        .load(url, function (responseText, textStatus) {
            if ('error' === textStatus) {
                return $(this).html(responseText);
            }
        })
    ;
}

function submitCopySurveyPopup(event) {
    event.preventDefault();
    const name = $(event.currentTarget).find('#name').val();

    $.ajax({
        type: "POST",
        headers: {'X-CSRF-TOKEN': getCsrfToken()},
        url: $(event.currentTarget).prop('action'),
        data: {
            'name': name
        },
        success: function () {
            $('#surveyCopyModal')
                .modal('hide')
                .on('hidden.bs.modal', function () {
                    run('/panel/survey/list/partials/draft');
                    const delayTime = 5000; // milliseconds
                    swalFire({
                        title: 'The survey copy has been created',
                        icon: 'success',
                        timer: delayTime
                    });
                });
        },
        error: function (data) {
            swalErrorFire({
                title: 'Error',
                text: data.responseJSON.errors.name[0]
            });
        }
    });
}

function showRestoreSurveyPopup(event) {
    event.preventDefault();

    const url = $(event.currentTarget).prop('href');
    const $surveyRestoreModal = $('#surveyRestoreModal');

    $surveyRestoreModal
        .modal('show')
        .find('.modal-content')
        .html('<div class="m-5 text-center">' +
            '<div class="spinner-border mb-3" role="status"></div>' +
            '<strong class="d-block">Loading data, please wait...</strong>' +
            '</div>')
        .load(url, function (responseText, textStatus) {
            if ('error' === textStatus) {
                return $(this).html(responseText);
            }

            attachNumber($(event.delegateTarget));
            setSampleState();
        });
}

function setSampleState() {
    const isUnlimitedTargetChecked = $(document.getElementById('unlimited-target')).is(':checked');
    $(document).find('#targetGeneral, #oversamplingGeneral').prop('readonly', isUnlimitedTargetChecked);
    $(document).find('.input-group-prepend, .input-group-append').children().prop('disabled', isUnlimitedTargetChecked);
}
